<template>
   <v-container fluid style="padding:0px;">

            <v-row style="height:100%; padding:0px">
              <v-col cols="7" style="padding:0px">
  
                  <v-data-table class="payroll-data-table"
                     disable-filtering disable-pagination single-select 
                     :value="selectedItem" v-on:item-selected="onItemSelected" item-key="employeeId"
                     @click:row = "onClickRow"
                    :headers="headers"
                    :items="items"
                ></v-data-table> 
              </v-col>

              <v-col cols="5"><object :data="previewUrl" type="application/pdf" width="100%" height="100%"></object>
              </v-col>

            </v-row>
        <v-snackbar
            v-model="showAlert"
            :timeout="alertTimeout"
            :color="alertColor">
                <span style="color: #ffffff;">{{alertText}}</span>
                <v-btn text @click="showAlert=false">
                <span style="color: #ffffff;">Cerrar</span>
                </v-btn>
            </v-snackbar>
            
    </v-container>
</template>

<script> 

//import api from '../../api/worktime'

import BaseModule from '../common/BaseModule.js'

export default {
  name: 'PayrollPreviewModule',
  survey: null,
  mixins: [BaseModule],
  components: { 
   
  },
  
  data() {
      return {
        tab: null,
        loading: false,
        submissionInfo: {},
        items: [],
        showAlert: false,
        alertColor: 'error',
        alertText: '',
        alertTimeout: 3000,
        showDialog: true,
        previewUrl: null,
        selectedItem: [],
        headers: [
          { text: this.$t('wkt.admin.documents-explore.edit-window.id'),value: 'idNumber'},
          { text: this.$t('wkt.admin.documents-explore.edit-window.lastname'), value: 'lastname' },
          { text: this.$t('wkt.admin.documents-explore.edit-window.firstname'), value: 'firstname' },
          { text: this.$t('wkt.admin.documents-explore.edit-window.pages'), value: 'pages' }
        ],
      }
  },
   methods: {
       doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
    onClickRow(item) {
      this.selectedItem = [item];
        this.previewUrl = item.previewPath+'#toolbar=0';
    },
    onItemSelected(event) {
      this.previewUrl = event.item && event.value?this.previewUrl=event.item.previewPath+'#toolbar=0':null;
      console.log(this.previewUrl)
    },
    onReveal(payload) {
        this.survey=payload;
        let data = payload.wizardData?JSON.parse(payload.wizardData):{};
        this.items=data.references?data.references:[];
        if (data.notFoundPages)
        {
          this.items.push({
              employeeId: -1,
              firstname: this.$t('wkt.admin.documents-explore.edit-window.notfound'),
              pages: data.notFoundPages,
              previewPath: data.notFoundPagesPreviewPath 
          });
        }
        this.showDialog = true;
        this.selectedItem = [this.items[0]];
        const me = this;
        setTimeout(()=>{
          me.previewUrl = me.items[0].previewPath+'#toolbar=0';
        },1000)
        
    }
   },
};
</script>